export default function capitalizeLabels(value) {
  return value.replace(/(?:^|\s)\w/g, c => c.toUpperCase())
}
